import type { DataSession } from "../../../../data/core/session";

import type { CatalogSong } from "../../domain/types";

/**
 * Fetches the popular songs for an artist from their profile.
 * This returns the curated "Popular" songs list, not all songs by the artist.
 */
export function createArtistsApi(data: DataSession) {
  const trpcVanillaClient = data.api;
  async function fetchArtistPopularSongs(
    artistId: string,
  ): Promise<CatalogSong[]> {
    console.audio.log("fetchArtistPopularSongs", { artistId });

    const artistProfile =
      await trpcVanillaClient.catalog.artists.getProfileById.query(artistId);

    if (!artistProfile?.popularSongs) {
      console.audio.warn("fetchArtistPopularSongs: no popular songs found", {
        artistId,
      });
      return [];
    }

    return artistProfile.popularSongs;
  }

  return { fetchArtistPopularSongs };
}
